import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import {
  AppState,
  formDataSpecifySelector
} from '..';
import { FetchFormData, LoadFormData, SaveData, LoadFormDataWithSync, LoadFormDataWithButtonSync } from './form-data.actions';
import { RxdbService } from 'src/app/services/rxdb.service';
import { StorageService } from 'src/app/services/storage.service';
import * as deepEqual from 'deep-equal';
import { ApiService } from 'src/app/services/api.service';

@Injectable({
  providedIn: 'root'
})

export class FormDataFacade {

  constructor(private store: Store<AppState>, private rxDB: RxdbService, private storage: StorageService, private api: ApiService) {}

  fetchFormData(id: string, agentId: number) {
    this.getDataFromDB(id, agentId).then(
      data => {
        if (data !== undefined && data !== null) {
          const subSectionOpen = this.storage.getSessionValue('subSection');
          if (subSectionOpen === 'caregiver_information') {
            this.store.dispatch(new LoadFormDataWithSync(data.toJSON().data));
          } else {
            console.log('participant_as_json', data.toJSON().data);
            this.api.setAssessmentStandAlonedata(data.toJSON().data.participant_as_json);
            this.store.dispatch(new LoadFormData(data.toJSON().data));
          }
        } else {
          this.store.dispatch(new FetchFormData(id, agentId));
        }
      }
    );
  }

  getSpecificValue(section) {
    const subSection = this.storage.getSessionValue('subSection');
    return this.store.pipe(select(formDataSpecifySelector, { section, subSection }));
  }

  insertDataToDB(apsReportLoadId: number, agendId: number, data: any) {
    this.rxDB.db.form_data.atomicUpsert({
      aps_report_load_id: apsReportLoadId.toString(),
      assigned_agent_id: agendId,
      data
    });
  }

  deleteDataToDB(ids: Array<string>) {
    this.rxDB.db.form_data.find().where('aps_report_load_id').in(ids).remove();
  }

  getDataFromDB(id: string, agentId?: number) {
    if (agentId !== undefined) {
      return this.rxDB.db.form_data
      .findOne()
      .where('aps_report_load_id').eq(id)
      .where('assigned_agent_id').eq(agentId)
      .exec();
    }
    return this.rxDB.db.form_data
    .findOne()
    .where('aps_report_load_id').eq(id)
    .exec();
  }

  updateDataToDB(apsReportLoadId: number, assignedAgentId: number, data: any, parentSection: string, isSaveManual: boolean) {
    this.getDataFromDB(apsReportLoadId.toString(), assignedAgentId).then(
      DBdata => {
        const jsonData = DBdata.toJSON();
        if (parentSection === 'aps_intake_report') {
          jsonData.data.intake_report.json_data = JSON.stringify(data);
        } else if (parentSection === 'investigation') {
          if (!deepEqual(JSON.parse(jsonData.data.investigation.json_data), data)) {
            jsonData.data.investigation.has_change_investigation = true;
          }
          jsonData.data.investigation.json_data = JSON.stringify(data);
        } else if (parentSection === 'client_identification_demographics') {
          if (!deepEqual(JSON.parse(jsonData.data.investigation.json_data).aps_report_load.victims, data.aps_report_load.victims)) {
            jsonData.data.investigation.has_change_victim = true;
          }
          jsonData.data.investigation.json_data = JSON.stringify(data);
        } else if (parentSection === 'contacts') {
          jsonData.data.contacts = data;
        } else if (parentSection === 'assessments') {
          jsonData.data.assessments = data;
        } else if (parentSection === 'progress_notes') {
          jsonData.data.notes = data;
        } else if (parentSection === 'closing_summary') {
          if (!deepEqual(jsonData.data.closing_summary, data)) {
            jsonData.data.closing_summary = {
              ...data,
              has_change: true
            };
          }
        } else if (parentSection === 'investigation_full') {
          if (!deepEqual(jsonData.data.investigation, data)) {
            jsonData.data.investigation.has_change_investigation = true;
          }
          jsonData.data.investigation = {
            ...jsonData.data.investigation,
            aps_decision_makers_at_close: data.aps_decision_makers_at_close,
            aps_decision_makers_at_start: data.aps_decision_makers_at_start,
            living_setting_at_close: data.living_setting_at_close,
            living_setting_at_start: data.living_setting_at_start
          };
        } else if (parentSection === 'fcc') {
          jsonData.data.fcc = {
            focused_care_coordinations: data,
            has_change: true
          };
        }


        if (parentSection !== undefined) {
          this.insertDataToDB(apsReportLoadId, assignedAgentId, jsonData.data);
        }
        if (isSaveManual) {
          this.store.dispatch(new LoadFormData(jsonData.data));
        }
        // console.log('save!updateDataToDB', parentSection, jsonData.data);
      }
    );
  }

  syncSection() {
    const assignedAgentId = +this.storage.getLocalValue('selectedAssignedAgentId');
    const apsReportLoadId = this.storage.getLocalValue('selectedID');
    this.getDataFromDB(apsReportLoadId, assignedAgentId).then(
      data => {
        this.store.dispatch(new LoadFormDataWithButtonSync(data.toJSON().data));
      }
    );
  }
}
